<template>
  <div class="dashboard">
    <header class="dashboard__header">
      <figure class="dashboard__header__logo">
        <router-link :to="{ name: 'Stats' }">
          <img src="@/assets/svg/logo-solency-white.svg" alt="" />
        </router-link>
      </figure>
      <div class="dashboard__header__tabs">
        <router-link class="dashboard__header__tabs__tab" :to="{ name: 'Stats' }">
          PERFORMANCE
        </router-link>
        <router-link
          class="dashboard__header__tabs__tab"
          :to="{ name: 'UsersList' }"
        >
          UTILISATEURS
        </router-link>
      </div>
      <div class="dashboard__header__user-info">
        <a class="dashboard__header__user-info__logout-link" @click="logout">
          QUITTER
        </a>
      </div>
    </header>
    <div class="dashboard__body">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  async mounted() {
    await this.fetchStats();
  },

  methods: {
    ...mapActions({
      fetchStats: 'stats/fetchStats',
      authLogout: 'auth/logout',
    }),

    async logout() {
      await this.authLogout();

      this.$router.push({ name: 'Connection' });
    },
  },
};
</script>
